import { render, staticRenderFns } from "./base-autocomplete.vue?vue&type=template&id=534da51c&scoped=true"
import script from "./base-autocomplete.ts?vue&type=script&lang=ts&external"
export * from "./base-autocomplete.ts?vue&type=script&lang=ts&external"
import style0 from "./base-autocomplete.vue?vue&type=style&index=0&id=534da51c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534da51c",
  null
  
)

export default component.exports